import { render, staticRenderFns } from "./ProgramaWrapper.vue?vue&type=template&id=20669859"
import script from "./ProgramaWrapper.vue?vue&type=script&lang=js"
export * from "./ProgramaWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports